Namespace 'Monitoring.Views.Dashboards'

class Monitoring.Views.Dashboards.TagsHierarchyModalView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents/tags_editor/tags_hierarchy_modal']

  events:
    'click .modal-closer': 'closeModal'

  initialize: ({currentTags, translator, firstLevelNodes, includeAlternativeTaxonomies}) ->
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyView({
      currentTags, translator, firstLevelNodes, includeAlternativeTaxonomies
    })
    @listenTo @tagsHierarchyView, 'selected:tags', (selectedTags) => @trigger('selected:tags', selectedTags)
    @listenTo @tagsHierarchyView, 'modal:close', @closeModal
    @searchBoxView = new Monitoring.Views.Dashboards.TagsHierarchySearchBoxView()
    @listenTo @searchBoxView, 'search-box:search', @search

  render: ->
    @$el.html @template
    @$('.modal-content-container').html @tagsHierarchyView.render().el
    @$('.tags-hierarchy-search-box-container').html @searchBoxView.render().el
    @

  showModal: ->
    @$('#tags-hierarchy-modal').modal('show')

  closeModal: =>
    @$('#tags-hierarchy-modal').modal('hide')

  search: ({value}) =>
    @tagsHierarchyView.searchTree value
